import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { LOGO } from "@/lib/images";
import SocialIcons from "@/components/SocialIcons";

const groups = [
  { title: "Stemmen", links: [["Stemmen bekijken", "/kinderstemmen"], ["Talen", "/kinderstemmen"], ["Shortlist", "/shortlist"]] },
  { title: "Casting", links: [["Castingservice", "/casting"], ["Start een casting", "/casting"]] },
  { title: "AI-stemmen", links: [["AI-stemmen", "/ai-voices"], ["AI-stemgenerator", "https://app.voiceoverkids.agency/main"], ["Hoe het werkt", "/ai-voices"]] },
  { title: "Studio", links: [["Studio", "/studio"], ["Regie op afstand", "/studio"], ["Levertijd & tarieven", "/studio"]] },
  { title: "Bedrijf", links: [["Over ons", "/about"], ["Werk / Klanten", "/work"], ["Podcast", "/podcast"], ["Aanmelden", "/aanmelden"], ["Contact", "/contact"]] },
  { title: "Juridisch", links: [["Privacy", "/privacy"], ["Voorwaarden", "/terms"]] },
];

export default function Footer() {
  return (
    <footer className="bg-brand-ink text-zinc-300">
      <div className="container-x py-16">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_2fr]">
          <div>
            <Link to="/" className="flex items-center gap-2.5 font-heading text-xl font-extrabold text-white">
              <img src={LOGO} alt="VoiceOverKids.Agency logo" className="h-11 w-11 object-contain" />
              <span>VoiceOverKids<span className="text-brand-purple">.Agency</span></span>
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-zinc-400">
              Het gespecialiseerde internationale bureau voor professionele kinderstemmen. Echte kinderen. Echte stemmen. Wereldwijd.
            </p>
            <div className="mt-6 space-y-2 text-sm text-zinc-400">
              <a href="mailto:bookings@voiceoverkids.agency" className="flex items-center gap-2 hover:text-white"><Mail size={15} /> bookings@voiceoverkids.agency</a>
              <a href="tel:+31712032441" className="flex items-center gap-2 hover:text-white"><Phone size={15} /> +31 71 2032441</a>
              <span className="flex items-center gap-2"><MapPin size={15} /> Leiden, Nederland</span>
            </div>
            <SocialIcons className="mt-6" size={18} dark />
          </div>
          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            {groups.map((g) => (
              <div key={g.title}>
                <h4 className="label-eyebrow text-zinc-500 mb-3">{g.title}</h4>
                <ul className="space-y-2">
                  {g.links.map(([label, href]) => (
                    <li key={label}>
                      {href.startsWith("http")
                        ? <a href={href} target="_blank" rel="noreferrer" className="text-sm text-zinc-400 hover:text-white">{label}</a>
                        : <Link to={href} className="text-sm text-zinc-400 hover:text-white">{label}</Link>}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="mt-14 flex flex-col gap-2 border-t border-white/10 pt-6 text-xs text-zinc-500 sm:flex-row sm:justify-between">
          <span>© {new Date().getFullYear()} VoiceOverKids.Agency · KVK 53824784 · BTW NL001977309B09</span>
          <Link to="/admin" className="hover:text-zinc-300">Personeelslogin</Link>
        </div>
      </div>
    </footer>
  );
}
